import React from 'react'

export const Page = ({ children, className }) => (
    <div className={'container-fluid ' + className}>
        {children}
    </div>
)
